import { GameState, Ray, Guess, Location, RayResult } from "../../../types/GameTypes";
import { startingGame } from "../Context/Context";
import { Penalty } from "./EngineHook";

export type ActionType = "LOAD" | "ADD_GUESS" | "REMOVE_GUESS" | "REMOVE_PATHS" | "ADD_RAY";

export type Action =
  | {
      type: "LOAD";
      payload: GameState;
    }
  | {
      type: "ADD_GUESS";
      payload: Location;
    }
  | {
      type: "REMOVE_GUESS";
      payload: Location;
    }
  | {
      type: "ADD_RAY";
      payload: Ray;
    };

export function gameReducer(state: GameState, action: Action): GameState {
  if (state.state === "VOID") return { ...state };

  switch (action.type) {
    case "LOAD":
      let newGame: GameState = action.payload;
      if (!newGame) newGame = { ...startingGame, state: "VOID" };
      return { ...state, ...newGame };

    case "ADD_GUESS": {
      const guess: Location = action.payload;
      return { ...state, guesses: [...state.guesses, { location: guess }] };
    }

    case "REMOVE_GUESS": {
      const guess: Location = action.payload;
      return {
        ...state,
        guesses: state.guesses.filter((g: Guess) => g.location.x !== guess.x || g.location.y !== guess.y),
      };
    }

    case "ADD_RAY": {
      const ray: Ray = action.payload;
      const newScore: number = (state.score += penaltyFor(ray.result));
      return { ...state, rays: [...state.rays, ray], score: newScore };
    }

    default:
      throw new Error("Unknown action");
  }
}

export function penaltyFor(result: RayResult) {
  switch (result) {
    case "DETOUR":
      return Penalty.detour;
    case "HIT":
      return Penalty.hit;
    case "REFLECTION":
      return Penalty.reflection;
    default:
      throw new Error(`Unknown result type ${result}`);
  }
}
